import { Button } from '../ui/button'
import ModalContainer from './modal-container'

interface LogoutModalProps {
  show: boolean
  handleClose: () => void
  handleLogout?: () => void
  loading?: boolean
}

export default function LogoutModal({
  show,
  handleClose,
  handleLogout,
  loading = false,
}: LogoutModalProps) {
  return (
    <ModalContainer
      show={show}
      hasCloseButton
      modalClass='lg:w-[30rem]'
      handleClose={handleClose! && handleClose}
    >
      <div className=''>
        <h1 className='p-5 SFProBold text-2xl'>Want to Logout?</h1>
        <p className='px-5 block mt- text-gray-600 text-[1rem]'>
          Are you sure you want to log out? Please confirm by clicking
          &quot;Yes, logout&quot; or &quot;Cancel&quot;.
        </p>
        <div className='mt-4 flex justify-end pt-4'>
          <div className='flex items-center gap-3'>
            <Button
              size='lg'
              variant='outline'
              className='h-10 rounded-md px-6 ext-red-600 border-slate-800'
              onClick={handleClose}
            >
              Cancel
            </Button>
            <Button
              className='h-10 w-full rounded-md px-4 border-0 text-white'
              onClick={handleLogout}
              loading={loading}
              variant='destructive'
            >
              Yes, Logout
            </Button>
          </div>
        </div>
      </div>
    </ModalContainer>
  )
}
